import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyCustomReportRoute: InvariantJiraRoute = {
	name: 'legacy-custom-report',
	path: '/secure/RapidBoard.jspa',
	query: ['rapidView', 'view=reporting', 'chart'],
};
